import algoliaApi from 'apis/algolia'
import { fetchVisiiSimilarApi } from 'apis/visii'
import { joinInstructions } from 'lib/algolia/query'
import { whitelistAlgoliaArtworkData, whitelistVisiiArtworkData } from './whitelist'
import { getLinkCategory, config } from '../helpers'

const RESULTS: number = 25

export const fetchRelatedArtworks = async ({
  artworkId,
  category,
  isArtist,
  mediums,
  sku,
  styles,
  subject,
  destinationZone,
}: Record<string, any>): Promise<Array<Record<string, any>>> => {
  let relatedArtworks: Array<Record<string, any>> = []

  // Don't Hit Visii if No Products/SKU AND if user is a Artist
  if (sku && !isArtist) {
    // Hit Visii for Related Artist work -> working sku => 'P1-U754038-A2598869'
    const visiiResults = await fetchVisiiSimilarApi(artworkId, destinationZone)

    if (visiiResults && visiiResults.results && visiiResults.results.length) {
      relatedArtworks = (visiiResults.results || [])
        .map(whitelistVisiiArtworkData) // Transform data using related transformer
        .filter((data) => data.sku !== sku) // Remove Current Item
        .slice(0, RESULTS)
    }
  }

  // If NO results from Visii, hit Algolia for Related Artwork
  if (!relatedArtworks || !relatedArtworks.length) {
    // Algolia Setup
    const algoliaOptions = {
      ...config,
      page: 0,
      hitsPerPage: RESULTS,
      // We will remove 1 ( and filter out CurrentArtwork ) back down to 10
      isBotTraffic: true, // Used to tell ALGOLIA if they should TRACK/ANALYTICS ( turn OFF in PDP )
    }
    const instructionSet = [
      {
        operator: 'OR',
        field: 'category',
        operands: [getLinkCategory(category)],
      },
      {
        operator: 'OR',
        field: 'styles',
        operands: styles || [],
      },
      {
        operator: 'OR',
        field: 'subject',
        operands: [subject],
      },
      ...(mediums
        ? (mediums || []).map((medium) => ({
            operator: 'OR',
            field: 'mediums',
            operands: [medium],
          }))
        : []),
    ]
    const filters = {
      filters: joinInstructions(instructionSet),
    }
    const algoliaResults = await algoliaApi({ ...algoliaOptions, ...filters })
    // Fetch results for query
    relatedArtworks = (algoliaResults.hits || [])
      .map(whitelistAlgoliaArtworkData) // Transform data using related transformer
      .filter((data) => data.sku !== sku) // Remove Current Item
      .slice(0, RESULTS)
  }

  return relatedArtworks
}
